import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const CustomModal = (props) => {
  return (
    <Modal isOpen={props.show} toggle={props.onHide} size={props.size} centered backdrop="static" keyboard={false}>
      <ModalHeader toggle={props.onHide}>
        <span className="text-md m-auto fw-500">{props.title}</span>
      </ModalHeader>

      <ModalBody style={{ maxHeight: props.showBtn ? '70vh' : '80vh', overflowY: 'auto' }}>
        {props.children}
      </ModalBody>

      {props.showBtn && (
        <ModalFooter>
          {props.isCancelBtn && (
            <Button className="btn btn-secondary btn-sm" onClick={props.onHide}>
              Cancel
            </Button>
          )}
          {props.isSaveBtn && (
            <Button className="btn btn-changan btn-sm" onClick={props.onSave}>
              Save
            </Button>
          )}
        </ModalFooter>
      )}
    </Modal>
  );
};

export default CustomModal;